<template>
    <div class="sal-filter-swatch">
        <div class="col-12" v-if="filter.title">
            <p class="filter__label group__label"><span v-html="filter.title" /></p>
        </div>
        <div class="filter__options row no-gutters">
            <template v-for="option in filter.options">
                <div class="swatch-wrapper">
                    <sal-filter-swatch-element :key="filter.key" :name="filter.name" :swatches="option"></sal-filter-swatch-element>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import SalFilterSwatchElement from "@productfinder/components/sal-filter-swatch/sal-filter-swatch-element";
    export default {
        name: "sal-filter-swatch",
        components: {SalFilterSwatchElement},
        props: {
            filter: {}
        }
    }
</script>
